import App from './App.svelte';
const CONTRACT = 'c680z7fefr'

const app = new App({
	target: document.body,
	props: {
		CONTRACT
	}
});

export default app;